import Integrante from '../types/Integrante';

const ordenarIntegrantes = (integrantes: Integrante[]): Integrante[] => {
    const tiposOrdenados: { [key: string]: number } = {
      'Titular': 1,
      'Conyuge': 2,
      'Menor': 3,
      'Mayor': 4,
    };
  
    return integrantes.slice().sort((a, b) => {
      const ordenA = tiposOrdenados[a.tipo];
      const ordenB = tiposOrdenados[b.tipo];
  
      if (ordenA < ordenB) return -1;
      if (ordenA > ordenB) return 1;
  
      if (a.tipo === 'Menor') {
        const apellidosComparados = a.apellido.localeCompare(b.apellido);
        if (apellidosComparados !== 0) return apellidosComparados;
        return a.nombres.localeCompare(b.nombres);
      }
  
      if (a.tipo === 'Mayor') {
        const apellidosComparados = a.apellido.localeCompare(b.apellido);
        if (apellidosComparados !== 0) return apellidosComparados;
        return a.nombres.localeCompare(b.nombres);
      }
  
      return 0;
    });
  };
  
  export default ordenarIntegrantes;